import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { PureComponent } from 'react';
import Spring from 'tiny-spring';
import styler from 'stylefire';

var AnimateScroll = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(AnimateScroll, _PureComponent);

  function AnimateScroll() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "setRef", function (node) {
      if (!_this.scroller) {
        _this.scroller = styler(node);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setScroll", function (side, amount) {
      var spring = Spring(_this.scroller.get(side), {
        stiffness: 500,
        damping: 50
      });
      spring.onUpdate(function (value) {
        var _this$scroller$set;

        return _this.scroller.set((_this$scroller$set = {}, _this$scroller$set[side] = value, _this$scroller$set));
      });
      spring.transitionTo(amount);
    });

    _defineProperty(_assertThisInitialized(_this), "setScrollX", function (amount) {
      _this.setScroll('scrollLeft', amount);
    });

    _defineProperty(_assertThisInitialized(_this), "setScrollY", function (amount) {
      _this.setScroll('scrollTop', amount);
    });

    _defineProperty(_assertThisInitialized(_this), "moveScroll", function (side, amount) {
      _this.setScroll(side, _this.scroller.get(side) + amount);
    });

    _defineProperty(_assertThisInitialized(_this), "moveScrollX", function (amount) {
      _this.moveScroll('scrollLeft', amount);
    });

    _defineProperty(_assertThisInitialized(_this), "moveScrollY", function (amount) {
      _this.moveScroll('scrollTop', amount);
    });

    return _this;
  }

  var _proto = AnimateScroll.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (!this.scroller) {
      this.scroller = styler(window);
    }
  };

  _proto.render = function render() {
    return this.props.children({
      ref: this.setRef,
      moveScrollX: this.moveScrollX,
      moveScrollY: this.moveScrollY,
      setScrollX: this.setScrollX,
      setScrollY: this.setScrollY
    });
  };

  return AnimateScroll;
}(PureComponent);

export default AnimateScroll;